import { PerkDefinition } from "./types";

export const perkThorns = {
  id: "perk_thorns",
  name: "Thorns",
  description: "When you take damage, deal 1 damage back to the attacker.",
  apply: () => {
    // No stat modifications on apply
  },
  onDamageTaken: (_damageAmount, context) => {
    // Reflect 1 damage per stack back to the attacker
    // applyDamage handles the reflection through context
    const reflectionDamage = context.stackCount * 1;
    context.applyDamage(reflectionDamage);
    return 0; // No healing or additional effect
  },
} satisfies PerkDefinition<"perk_thorns">;
